import type { FC } from 'react'
import cn from 'classnames'
import dynamic from 'next/dynamic'
import { Loading } from 'components/ui'
import { Footer, Navbar } from 'components/layout'
import { CartListItems, CartWidget } from 'modules/cart/containers'
import { useMercadinho } from 'hooks/use-mercadinho'
import s from './layout.module.css'
import { LayoutProps } from '.'

const dynamicProps = {
  loading: () => <Loading />,
}

const AcceptCookies = dynamic(() => import('components/layout/accept-cookies'), dynamicProps)

const Layout: FC<LayoutProps> = ({ children, header = true, footer = true }) => {
  const { isMercadinho } = useMercadinho()
  return (
    <>
      <CartWidget>
        <CartListItems fromWidget />
      </CartWidget>
      <div className={cn(s.root)}>
        {header && <Navbar />}
        <main className={s.root}>{children}</main>
        <AcceptCookies />
        {footer && !isMercadinho && <Footer />}
      </div>
    </>
  )
}

export default Layout
